import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';
import { mockFullLoggedOutUser } from './mockFullLoggedOutUser';

export const mockFullLoggedOutUserManyBadges: MockResponseConfig = {
  ...mockFullLoggedOutUser,

  UnifiedProfileQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          ...mockFullLoggedOutUser.UnifiedProfileQuery(variables).data.unified
            .unifiedProfile,
          username: 'loggedoutmanybadges',
        },
      },
    },
  }),
  ProfileBadgesQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          aaid: '62587f99fdb60b0069294184',
          learning: {
            __typename: 'UnifiedLearning',
            id: 'ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184',
            recentCoursesBadges: {
              __typename: 'UnifiedProfileBadgesConnection',
              edges: [],
              totalCount: 0,
            },
          },
          badges: {
            __typename: 'UnifiedProfileBadgesConnection',
            edges: [
              ...new Array(1103).fill(null).map((_, index) => ({
                node: {
                  description: 'Answer 1 question tagged “cloud”',
                  id: `ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-kms-4837589`,
                  imageUrl:
                    'https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/challenge_thumbUrl-1617314058161?1617314067530',
                  name: 'Cloudie',
                  type: 'kms',
                },
              })),
            ],
            pageInfo: {
              endCursor: '1103',
              hasNextPage: false,
              hasPreviousPage: false,
              startCursor: '0',
            },
            totalCount: 1103,
          },
        },
      },
    },
  }),
};
